// src/composables/useCommonHead.js

import { useHead } from '@vueuse/head';

export function useCommonHead(pageTitle, pageDescription, currentUrl,nextPageUrl) {
    useHead({
        title: pageTitle,
        meta: [
            { name: 'description', content: pageDescription },
            { name: 'robots', content: 'follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large' },
            { property: 'og:locale', content: 'en_US' },
            { property: 'og:type', content: 'website' },
            { property: 'og:title', content: pageTitle },
            { property: 'og:description', content: pageDescription },
            { property: 'og:url', content: currentUrl },
            { property: 'og:site_name', content: 'Arrify' },
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: pageTitle },
            { name: 'twitter:description', content: pageDescription },
            { name: 'twitter:site', content: '@arrifyITS' },
        ],
        link: [
            { rel: 'canonical', href: currentUrl },
            ...(nextPageUrl ? [{ rel: 'next', href: nextPageUrl }] : []),
        ],
        script: [
            {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                    "@context": "https://schema.org",
                    "@graph": [
                        {
                            "@type": "Organization",
                            "@id": "https://arrify.com/#organization",
                            "name": "Arrify",
                            "url": "https://arrify.com",
                            "sameAs": ["https://twitter.com/arrifyITS"],
                            "logo": {
                                "@type": "ImageObject",
                                "@id": "https://arrify.com/#logo",
                                "url": "https://arrify.com/wp-content/uploads/2018/12/cropped-Arrify_icon-copy.png",
                                "contentUrl": "https://arrify.com/wp-content/uploads/2018/12/cropped-Arrify_icon-copy.png",
                                "caption": "Arrify",
                                "inLanguage": "en-US",
                                "width": "512",
                                "height": "512"
                            }
                        },
                        {
                            "@type": "WebSite",
                            "@id": "https://arrify.com/#website",
                            "url": "https://arrify.com",
                            "name": "Arrify",
                            "publisher": {"@id": "https://arrify.com/#organization"},
                            "inLanguage": "en-US"
                        },
                        {
                            "@type": "WebPage",
                            "@id": `${currentUrl}#webpage`,
                            "url": currentUrl,
                            "name": pageTitle,
                            "isPartOf": {"@id": "https://arrify.com/#website"},
                            "inLanguage": "en-US",
                            "datePublished": "2023-08-27T12:00:00+00:00",
                            "dateModified": "2023-08-27T12:00:00+00:00",
                            "description": pageDescription,
                            "breadcrumb": {"@id": `${currentUrl}#breadcrumb`}
                        },
                        {
                            "@type": "BreadcrumbList",
                            "@id": `${currentUrl}#breadcrumb`,
                            "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": "1",
                                    "item": {"@id": "https://arrify.com", "name": "Home"}
                                },
                                {
                                    "@type": "ListItem",
                                    "position": "2",
                                    "item": {"@id": currentUrl, "name": pageTitle.split(' - ')[0]}
                                }
                            ]
                        }
                    ]
                })
            }
        ]
    });
}